import { getPostRole } from '../../utils/getPostRole'
export const postExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Post Title',
		render: p => p?.title || '',
	},
	{
		label: 'Category',
		render: p => p?.category || '',
	},
	{
		label: 'Community',
		render: p => p?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: p => p?.sanstha?.name || '',
	},
	{
		label: 'Created Date',
		render: p => (p?.createdAt ? new Date(p.createdAt).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Posted By',
		render: p => (p?.user ? `${p.user.firstName || ''} ${p.user.lastName || ''}`.trim() : ''),
	},
	{
		label: 'Posted Role',
		render: p => getPostRole(p),
	},
]
